import React from 'react';
import { LayoutContext } from '../components/LayoutProvider';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Layout = ({ children }) => {
    const { isHeaderVisible, isFooterVisible } = React.useContext(LayoutContext);

    return (
        <div className="flex flex-col min-h-screen w-full">
            {isHeaderVisible && <Header className="sticky top-0 z-50 w-full" />}
            <main className="flex-grow flex w-full overflow-hidden">
                {children}
            </main>
            {isFooterVisible && <Footer className="mt-auto w-full" />}
        </div>
    );
};

export default Layout;